export enum FilterDataType {
  STATUS = 'Status',
  TYPE = 'Type',
  DATE = 'Date',
  AMOUNT = 'Amount',
  ZONE = 'Health',
}

export interface IFilterData {
  type?: FilterDataType
  content: string
  data: string
  onClick: () => void
  count: number
  filters: string[]
  imgSrc?: string
  onDestroy: () => void
  onHide?: () => void
  isDestroying?: boolean
}

export function addFilterData(target: IFilterData[], data: IFilterData, t: (any) => any): IFilterData[] {
  if (!target || !data) {
    return target
  }
  const existingItemIndex = target.findIndex((item) => item.type === data.type)

  if (existingItemIndex !== -1) {
    const existingItem = target.find((item) => item.type === data.type)

    if (existingItem.filters.some((filter) => data.filters.includes(filter))) {
      return target
    }
    existingItem.count += 1

    let newContent = ''
    if (existingItem.count > 2) {
      const firstItem = existingItem.content.includes(',')
        ? existingItem.content.split(',')[0]
        : existingItem.content.split('+')[0]
      newContent = t(firstItem.toLowerCase()) + ` + ${existingItem.count - 1} ${t('more')}`
    } else {
      newContent = t(existingItem.content.toLowerCase()) + ', ' + t(data.content.toLowerCase())
    }
    existingItem.filters.push(...data.filters)

    target[existingItemIndex] = {
      ...target[existingItemIndex],
      content: newContent,
    }
  } else {
    target.push(data)
  }
  target = target.sort((a, b) => {
    if (a.type === null && b.type !== null) {
      return -1 // a идет перед b
    } else if (a.type !== null && b.type === null) {
      return 1 // b идет перед a
    } else {
      return 0 // a и b остаются на своих местах
    }
  })
  return target
}

export function removeFilterData(target: IFilterData[], data: IFilterData, t: (any) => any): IFilterData[] {
  if (!target || !data) {
    return target
  }

  const existingItem = target.find((item) => item.type === data.type)

  if (!existingItem) {
    return []
  }

  existingItem.count -= 1

  existingItem.filters = existingItem.filters.filter((item) => !data.filters.includes(item))

  if (existingItem.filters.length === 1) {
    existingItem.content = t(existingItem.filters[0].toLowerCase())
  } else if (existingItem.filters.length === 2) {
    existingItem.content = t(existingItem.filters[0].toLowerCase()) + ', ' + t(existingItem.filters[1].toLowerCase())
  } else if (existingItem.filters.length > 2) {
    existingItem.content = t(existingItem.filters[0].toLowerCase()) + ` + ${existingItem.count - 1} ${t('more')}`
  } else {
    target = target.filter((item) => item.type !== data.type)
  }

  if (target.length === 2) {
    target = target.filter((item) => item.type !== null)
  }

  return target
}
